import { Link } from "@/components/LangLink";
import { Pill, Stethoscope, Store, Truck, Hospital, Users, ArrowRight } from "lucide-react";
import { PageHero, CTASection } from "@/components/sections";
import { Stagger, StaggerItem } from "@/components/primitives";
import { CHANNELS } from "@/lib/site";

const ICONS = [Pill, Store, Truck, Stethoscope, Hospital, Users];

const Canali = () => (
  <>
    <PageHero
      eyebrow="Canali"
      title={"A chi ci\nrivolgiamo."}
      subtitle="Medisistem è il punto di riferimento per la terapia elasto-compressiva: dalla farmacia al medico specialista, fino al paziente, a ciascun canale offriamo competenza, prodotti certificati e assistenza dedicata."
      testid="canali-hero"
    />

    <section className="py-20 lg:py-28 bg-white" data-testid="canali-grid">
      <div className="container-x">
        <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CHANNELS.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <StaggerItem key={c.id}>
                <div className="card-clean h-full p-8 group" data-testid={`canale-${c.id}`}>
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-green/10 text-green transition-colors duration-300 group-hover:bg-green group-hover:text-white">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-6 font-serif text-2xl font-bold text-navy">{c.title}</h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{c.desc}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>

        <div className="mt-16 rounded-3xl bg-navy p-10 lg:p-12 text-white flex flex-col lg:flex-row lg:items-center justify-between gap-6" data-testid="canali-professionisti">
          <div className="max-w-2xl">
            <span className="eyebrow text-green/90">Sei un professionista o una struttura?</span>
            <h3 className="mt-4 font-serif text-2xl lg:text-3xl font-bold">Costruiamo insieme una collaborazione.</h3>
            <p className="mt-4 text-white/70 leading-relaxed">
              Contattaci per informazioni professionali, condizioni di fornitura e supporto tecnico dedicato al tuo canale.
            </p>
          </div>
          <Link to="/contatti" data-testid="canali-cta" className="btn-green shrink-0">
            Contattaci <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>

    <CTASection />
  </>
);

export default Canali;
